import { Navigate, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Community } from './people';
import { NotFoundErrorPage } from '@bizzabo/design-system';
import useAgendaUrl from 'hooks/useVenueUrl/useAgendaUrl';
import AppExtensionMainNav from './extensions/components/AppExtensionMainNav';

const Agenda = lazy(() => import('./agenda'));

const VenueRoutes = ({ eventUniqueName }) => {
    const url = useAgendaUrl();
    return (
        <Routes>
            <Route path="/*" element={<Navigate replace to={url} />} />
            <Route
                path="/agenda/*"
                element={
                    <Suspense fallback={null}>
                        <Agenda />
                    </Suspense>
                }
            />
            <Route path="/community/*" element={<Community eventUniqueName={eventUniqueName} />} />
            <Route path="/extension/:extensionId/*" element={<AppExtensionMainNav />} />
            <Route element={NotFoundErrorPage} />
        </Routes>
    );
};

export default VenueRoutes;
